export const FIELD_INPUT_EXAMPLES = [
  {
    label: 'Address',
    element: 'address',
    required: true,
    collect: 'billing',
    defaultCountry: 'US',
  },
  {
    label: 'Address',
    element: 'address',
    required: true,
    collect: 'billing_and_shipping',
    collectShippingPhone: true,
    defaultCountry: 'US',
    limitShippingCountries: {
      enabled: true,
      countries: ['US', 'CA'],
    },
  },
  {
    label: 'Company Name',
    element: 'text',
    type: 'company-name',
    required: true,
    placeholder: 'Enter your company name',
  },
  {
    label: 'Additional Notes',
    element: 'textarea',
    required: false,
    placeholder: 'Tell us anything we should know',
  },
  {
    label: 'Number of Team Seats',
    element: 'number',
    required: true,
    placeholder: '1',
  },
  {
    label: 'Quantity',
    element: 'quantity',
    required: true,
  },
  {
    label: 'Start Date',
    element: 'date',
    required: true,
  },
  {
    label: 'Preferred Time',
    element: 'time',
    required: false,
  },
  {
    label: 'Appointment Date & Time',
    element: 'date-time',
    required: false,
  },
  {
    label: 'Purchase Order Number',
    element: 'po-number',
    required: false,
    placeholder: 'PO-2026-001',
  },
  {
    label: 'Business Email',
    element: 'email',
    type: 'email',
    required: true,
    placeholder: 'you@company.com',
  },
  {
    label: 'Phone Number',
    element: 'phone',
    type: 'phone',
    required: true,
    placeholder: '+1 555 123 4567',
  },
  {
    label: 'Tax ID',
    element: 'tax-id',
    required: false,
    placeholder: '12-3456789',
  },
  {
    label: 'Country',
    element: 'country',
    type: 'address-country',
    required: true,
  },
  {
    label: 'I agree to the terms',
    element: 'checkbox',
    required: true,
  },
  {
    label: 'Plan',
    element: 'select',
    required: true,
    options: [
      { label: 'Starter', value: 'starter' },
      { label: 'Pro', value: 'pro' },
      { label: 'Enterprise', value: 'enterprise' },
    ],
  },
  {
    label: 'How did you hear about us?',
    element: 'multi-select',
    required: false,
    options: [
      { label: 'Google', value: 'google' },
      { label: 'Facebook', value: 'facebook' },
      { label: 'A friend', value: 'friend' },
    ],
  },
  {
    label: 'T-Shirt Size',
    element: 'multiple-choice',
    required: true,
    options: [
      { label: 'Small', value: 's' },
      { label: 'Medium', value: 'm' },
      { label: 'Large', value: 'l' },
    ],
  },
  {
    key: 'shipping-method',
    label: 'Shipping Method',
    element: 'select',
    required: true,
    reference: 'shipping-method',
    options: [
      { key: 'digital-delivery', label: 'Digital Delivery', value: 'digital' },
      { key: 'physical-delivery', label: 'Physical Delivery', value: 'physical' },
    ],
  },
  {
    key: 'shipping-address',
    label: 'Address',
    element: 'address',
    required: true,
    collect: 'billing',
    showHideLogic: {
      enabled: true,
      comparison: 'is',
      value: 'physical-delivery',
      element: {
        elementType: 'field',
        elementId: 'shipping-method',
      },
    },
  },
  {
    label: 'Shipping Address Line 1',
    element: 'text',
    type: 'shipping-address-line1',
    reference: 'shipping-address-line1',
  },
];
